import type { JSX } from 'react';

import { HowChangeWorks } from './components/HowChangeWorks';
import { InfoCards } from './components/InfoCards';
import { WhoUses } from './components/WhoUses';

export function PageBody(): JSX.Element {
	return (
		<>
			<WhoUses />
			<HowChangeWorks />
			<InfoCards />
		</>
	);
}
